module.exports = __webpack_public_path__ + "static/media/save_pdf_icon.3a15009f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/save_pdf_icon.svg
// module id = 854
// module chunks = 0